var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"samples-view"},[_c('samples-filter',{ref:"samplesFilter"}),_vm._v(" "),_c('samples-list',{on:{"requestSamplesListUpdate":_vm.handleRequestSamplesListUpdate}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }